import i18n from 'i18next'
import { reactI18nextModule } from 'react-i18next'
import intervalPlural from 'i18next-intervalplural-postprocessor'

import { bg } from './translations/bg'
import { en } from './translations/en'
import { ru } from './translations/ru'

i18n
  // Chain modules
  .use(intervalPlural)
  .use(reactI18nextModule)
  .init({
    lng: 'bg',
    fallbackLng: 'bg',
    debug: false,

    // React already does escaping
    interpolation: {
      escapeValue: false,
    },
    react: { wait: true },

    // Note: Best practice is to load that via xhr. Anyways.
    resources: {
      // 'translation' is the default namespace, simply use this one.
      bg: { translation: bg },
      en: { translation: en },
      ru: { translation: ru },
    },
  });

export default i18n



// WEBPACK FOOTER //
// ./src/utils/i18n.js